<!--
 * @Author: Junjie
 * @Date: 2022-06-23 17:05:33
 * @LastEditTime: 2022-11-25 14:00:07
 * @email: 781433561@qq.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/monitor/datas/modules/PointsLineChartModal.vue
-->

<template>
  <j-modal
    :getPopupContainer="getPopupContainer"
    :okButtonProps="{ style: { display: 'none' } }"
    :title="title"
    :visible="visible"
    :width="width"
    @cancel="handleCancel"
    cancelText="关闭"
    style="max-height: 85vh; "
    switchFullscreen
    v-bind="$attrs"
  >
    <points-line-chart ref="dataLine"></points-line-chart>
  </j-modal>
  <!--  :getPopupContainer="getPopupContainer" -->
</template>

<script>
import PointsLineChart from './PointsLineChart'
export default {
  name: 'PointsLineChartModal',
  components: {
    PointsLineChart
  },

  props: {},
  data() {
    return {
      title: '数据曲线',
      width: 1200,
      visible: false,
      disableSubmit: true
    }
  },
  methods: {
    show(ponitsStr, timeRange, alertTime, fastTimeRange, marks) {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.dataLine.loadData(ponitsStr, timeRange, alertTime, fastTimeRange, marks)
      })
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleCancel() {
      this.close()
    },
    getPopupContainer() {
      if (document.fullscreen) {
        return document.getElementById('fullscreen')
      }
    }
  }
}
</script>
